<div *ngIf="!isLoading" class="home-grid">
  <div>
    <app-mini-square-bar
      [openCalls]="openCalls"
      [ongoingCalls]="ongoingCalls"
      [pendingCalls]="pendingCalls"
      [thisMonthCalls]="thisMonthCalls"
      [closedTodayCalls]="closedTodayCalls"
    ></app-mini-square-bar>
  </div>
  <div class="home-sub-grid">
    <app-year-data-chart
      class="responsive-home-chart"
      [chartInfo]="monthlyCalls"
    ></app-year-data-chart>
    <app-daily-phrase
      class="responsive-home-phrase"
    ></app-daily-phrase>
  </div>
</div>
<div class="fab-button responsive-home-fab">
  <button mat-fab color="primary" [routerLink]="'/operador/chamados/criar'">
    <mat-icon>add</mat-icon>
  </button>
</div>
